import { PaletteMode } from '@mui/material'
const THEME_MODE_KEY = 'theme_mode'

export const setThemeToStorage = (mode: PaletteMode): void => {
  localStorage.setItem(THEME_MODE_KEY, mode)
}

export const getThemeFromStorage = (): PaletteMode => {
  return localStorage.getItem(THEME_MODE_KEY) as 'light'|'dark' || 'light'
}